import React from "react";
import Slider from "react-slick";
import "../styles/slick/slick.css";
import "../styles/slick/slick-theme.css";
import "../styles/slider.css";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa6";


export function NextArrow(props) {
  const { className, style, onClick } = props
  return (
    <button aria-label="Next slide" className={`${className} `}>
      <FaChevronRight
        style={{ ...style }}
        onClick={onClick}
        className={`h-10 w-10 rounded p-2`}
      />
    </button>
  )
}

export function PrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <button aria-label="Previous slide" className={`${className} `}>
      <FaChevronLeft
        style={{ ...style }}
        onClick={onClick}
        className={`h-10 w-10 rounded p-2 `}
      />
    </button>
  )
}

export default function MultipleItemSlider({ props, children, overlay }) {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    className: "cursor-ew-resize sm:mx-4 sm:py-4",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },

    ],
  };

  return (
    <div className={overlay ? "" : `container`}>
      <Slider {...settings}>
        {children}
      </Slider>
    </div>
  );
}
